import { defineMessages } from 'react-intl'

import { WASTE_STATUS } from './constants'

export const wasteStatusMessages = defineMessages({
  [WASTE_STATUS.CREATED]: {
    id: 'spanish.waste.status.created',
    defaultMessage: 'Creado'
  },
  [WASTE_STATUS.CANCELLED]: {
    id: 'spanish.waste.status.cancelled',
    defaultMessage: 'Cancelado'
  }
})
